import { Component, OnInit } from '@angular/core';
import { ConstantsService, CompaniesEnum, LookupsService, SessionService } from '@app/base/core';
import {AlertService} from '@app/base/alerts/alert.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {
  companiesEnum: typeof CompaniesEnum = CompaniesEnum;
  alertMsg: any = [];
  constructor(public sessionSvc: SessionService, public constantsSvc: ConstantsService,
    private alertService: AlertService, public lookupSvc: LookupsService) {
  }

  // used to call initial methods and subscribe to services
  ngOnInit() {
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      if (val) {
        this.alertMsg = (this.lookupSvc.bannerMessages.find(x => x.itemName === 'Company'
        ));
        this.alertService.success(this.alertMsg.message);
      }
    });
          }}

